exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".list .list-group-item span{cursor:pointer}.list .list-group-item span.checked{text-decoration:line-through;font-style:italic;color:#d0d0d0}.list .list-group-item button{display:inline-block;width:auto;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-264039f3","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MealPlan.vue
// module id = 73
// module chunks = 0